import { ListItemIcon } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import React from "react";
import { PaperComponent } from "../DraggablePaper";

export function ActionMenuItem({
  action,
  handleDialogOpen,
  dialogOpen,
  handleDialogClose,
  props,
  subMenu,
}) {
  const getClassName = () => {
    if (subMenu) {
      return "smaller-list-item-icon submenu";
    } else {
      return "smaller-list-item-icon";
    }
  };

  return (
    <div key={action.title}>
      <MenuItem
        key={action.title}
        onClick={handleDialogOpen}
        data-dialog={action.dataDialog}
        className={action.className}
      >
        <ListItemIcon className={getClassName()}>
          {action.icon ? (
            action.icon
          ) : (
            <KeyboardArrowRightIcon fontSize="small" color="primary" />
          )}
        </ListItemIcon>
        {action.title}
      </MenuItem>
      <Dialog
        PaperComponent={PaperComponent}
        open={dialogOpen === action.dataDialog}
        onClose={handleDialogClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth={action.width ? action.width : "sm"}
      >
        <div className="modal-form">
          <button
            className="close-modal-btn lnr-cross"
            onClick={handleDialogClose}
          ></button>
          <h2 id="draggable-dialog-title">
            {action.dialogTitleParam && action.dialogTitleParam(props.row)}
            {action.dialogTitle}
            {action.dialogTitlePostfix && action.dialogTitlePostfix(props.row)}
          </h2>
          {action.actionComponent(props, handleDialogClose)}
        </div>
      </Dialog>
    </div>
  );
}
